import { graphql } from '@api/generated';
import { VirtualAgentFiltersForConversationsPageQuery } from '@api/generated/graphql';

// Query for virtual agent settings used in ConversationsPage filters
// Only fetches fields needed for the agent filter dropdown
export const virtualAgentSettingsQuery = graphql(`
  query VirtualAgentSettingsForFilters {
    virtualAgentSettings {
      defaultSettings {
        settingId
        virtualAgent
      }
      accounts {
        settingId
        virtualAgent
        tenant {
          id
        }
      }
    }
  }
`);

export const virtualAgentFiltersQuery = graphql(`
  query VirtualAgentFiltersForConversationsPage {
    virtualAgentFilters {
      defaultSettings {
        defaultId
        virtualAgent
      }
      accounts {
        agentId
        virtualAgent
        legacyDefaultId
        tenant {
          id
        }
      }
    }
  }
`);

export type VirtualAgentFiltersQueryResult =
  VirtualAgentFiltersForConversationsPageQuery;
